// extracted by mini-css-extract-plugin
export default {"link":"Link_link__v0Hw7","link--alt":"Link_link--alt__Ygetv","link--no-underline":"Link_link--no-underline__h3xBC","link--bold":"Link_link--bold__nj1Oe"};